export const SHOW_SNACKBAR = "app/Notifier/ENQUEUE_SNACKBAR";
export const CLOSE_SNACKBAR = "app/Notifier/CLOSE_SNACKBAR";
export const REMOVE_SNACKBAR = "app/Notifier/REMOVE_SNACKBAR";
